export default __webpack_public_path__ + "static/media/outcess5.be348618.jpeg";